import {ref} from 'vue';
import {useEventListener} from '@vueuse/core';
import {onServiceWorkerActivated} from '../window-workbox';
import rootLogger from '../log';

const promises = [];

const log = rootLogger.getLogger('composables.useLoginStatus');
const loginStatus = ref({
    account: null,
    username: null,
});
const isLoginStatusValid = () => loginStatus.value.account && loginStatus.value.username;
const resolvePromises = () => {
    if (isLoginStatusValid()) {
        promises.map(ele => ele(loginStatus));
        promises.length = 0;
    }
};

// login status depends on the service worker, so we'll wait for it to be ready
onServiceWorkerActivated(async () => {
    // TODO: static urls do not belong here
    const initialToken = await fetch('/token-status')
        .then(response => response.json());

    loginStatus.value = {account: initialToken.account, username: initialToken.username};
    log.debug('useLoginStatus initialized ', loginStatus.value);
    resolvePromises();
    useEventListener(navigator.serviceWorker, 'message', (e) => {
        if (
            e.data && e.data.type === 'LOGIN_STATE_CHANGED'
        ) {
            loginStatus.value.account = e.data.account;
            loginStatus.value.username = e.data.username;
            log.debug('useLoginStatus updated ', loginStatus.value);
            resolvePromises();
        }
    });
});

/**
 * @typedef {Object} useLoginStatusReturn
 * @property {Ref<UnwrapRef<{account: string, username: string}>>} loginStatus
 * @property {Promise<loginStatus>} validStatus
 *
 * @return {useLoginStatusReturn}
 */
export function useLoginStatus()
{
    const { promise: validStatus, resolve } = Promise.withResolvers();
    if (isLoginStatusValid()) {
        resolve(loginStatus);
    } else {
        promises.push(resolve);
    }
    return { loginStatus, validStatus };
}
